export const ANALYTICS_CURRENCY = 'USD';

export const toMinorUnits = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = typeof value === 'number' ? value : parseFloat(String(value).replace(/[$,]/g, ''));
  return Number.isFinite(parsed) ? Math.round(parsed * 100) : null;
};

const getItemKey = (item, index) =>
  item?.cartItemKey ||
  item?.id ||
  item?.productID ||
  `${item?.formID || item?.formName || 'item'}:${item?.fundName || item?.fund || ''}:${item?.amount || item?.price || 0}:${index}`;

export const getCartItemQuantity = (item) => {
  const parsed = parseInt(item?.quantity, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
};

export const getCartItemAmount = (item) => {
  const parsed = parseFloat(item?.amount ?? item?.price ?? 0);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getCartTotalCents = (cartItems = []) =>
  cartItems.reduce((sum, item) => {
    const itemTotal = getCartItemAmount(item) * getCartItemQuantity(item);
    return sum + (toMinorUnits(itemTotal) || 0);
  }, 0);

export const getConfirmedAddedCartItems = (previousItems = [], nextItems = []) => {
  const previousQuantities = new Map();

  previousItems.forEach((item, index) => {
    previousQuantities.set(getItemKey(item, index), getCartItemQuantity(item));
  });

  return nextItems.reduce((addedItems, item, index) => {
    const key = getItemKey(item, index);
    const previousQuantity = previousQuantities.get(key) || 0;
    const nextQuantity = getCartItemQuantity(item);
    const quantityAdded = nextQuantity - previousQuantity;

    if (quantityAdded > 0) {
      addedItems.push({
        item,
        cartItemKey: key,
        quantityAdded,
        cartItemQuantity: nextQuantity,
      });
    }

    return addedItems;
  }, []);
};

export const buildCartItemAddedConfirmedProperties = ({
  item,
  cart,
  cartItemKey,
  quantityAdded,
  cartItemQuantity,
  cartElementId,
}) => {
  const cartItems = Array.isArray(cart?.cartItems) ? cart.cartItems : [];
  const amount = getCartItemAmount(item);

  return {
    cart_element_id: cartElementId || item?.cartElementID || item?.elementID || null,
    cart_item_key: cartItemKey || item?.cartItemKey || null,
    form_id: item?.formID || item?.formId || null,
    form_name: item?.formName || item?.fundraiser || null,
    form_type: item?.formType || item?.type || null,
    fund_name: item?.fundName || item?.fund || null,
    product_id: item?.productID || item?.productId || null,
    product_name: item?.productName || item?.name || null,
    amount,
    amount_cents: toMinorUnits(amount),
    frequency: item?.frequency || null,
    quantity_added: quantityAdded,
    cart_item_quantity: cartItemQuantity,
    cart_items_count: cartItems.length,
    cart_total_cents: getCartTotalCents(cartItems),
    monthly_bump_accepted: item?.monthlyBumpAccepted === true,
    monthly_bump_original_amount_cents: toMinorUnits(item?.monthlyBumpOriginalAmount),
    monthly_bump_amount_cents: toMinorUnits(item?.monthlyBumpAmount),
    one_time_to_monthly_conversion: item?.monthlyBumpAccepted === true,
    currency: ANALYTICS_CURRENCY,
  };
};
